import React from "react";
import "./WelocateBedroomFilter.css";

const OPTIONS = [
  { label: "Any", value: null },
  { label: "1+ bedrooms", value: 1 },
  { label: "2+ bedrooms", value: 2 },
  { label: "3+ bedrooms", value: 3 },
  { label: "4+ bedrooms", value: 4 },
  { label: "5+ bedrooms", value: 5 },
];

const WelocateBedroomFilter = ({ selected, onSelect }) => (
  <div className="wl-bedroom-filter">
    {OPTIONS.map(({ label, value }) => {
      const isSelected = selected === value;
      return (
        <button
          key={label}
          className={`wl-bedroom-filter__option${isSelected ? " wl-bedroom-filter__option--selected" : ""}`}
          onClick={() => onSelect(value)}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default WelocateBedroomFilter;
